
class constantes {
     urlApi = "https://api.sistemarms.com/apistore"; // Producción
     //urlApi = "http://10.10.100.254:5001"; // Desarrollo
}

export default new constantes();